import { Breadcrumb, Button, Col, Form, Row, Select } from "antd";
import Profile from "../profile/profile";
import styles from "./UpdateNetwork.module.scss";
import { Content } from "antd/es/layout/layout";
import { _adr } from "../../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import Loading from "../../../auxiliary/loader/loading";
import { useBaseInfo, useDealer } from "../../../../tools/api";
const UpdateNetwork = () => {
	const [t] = useTranslation("global");
	const nav = useNavigate();
	const [frmService] = Form.useForm();
	const location = useLocation();

	const { queryOperators } = useBaseInfo();
	const { updateMobileNetwork } = useDealer();

	const [updateLocation, setUpdateLocation] = useState({
		isLoading: true,
		purchase: location?.state || {},
		operator: [],
		isSuccessfull: false,
		changeOprator: "",
	});

	useEffect(() => {
		const callServices = async () => {
			if (location?.state) {
				setUpdateLocation((update) => ({ ...update, isLoading: false }));
				const response = await queryOperators();
				if (response) {
					setUpdateLocation((up) => ({ ...up, operator: response.Result }));
				}
			}
		};
		callServices();
	}, []);

	const handleSubmit = async (value) => {
		setUpdateLocation((up) => ({ ...up, isLoading: true }));
		const payload = {
			msisdn: updateLocation.purchase.inT_MSISDN,
			operators: value?.oprator,
		};
		const response = await updateMobileNetwork(payload);
		if (response) {
			const changeOprator = updateLocation.operator.find((o) => o.value === value?.oprator)?.name;
			setUpdateLocation((up) => ({ ...up, isSuccessfull: true, changeOprator: changeOprator }));
		}
		setUpdateLocation((up) => ({ ...up, isLoading: false }));
	};
	return (
		<>
			<div className={`container-main ${styles.container_list}`}>
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("corporateSearch.title") }]}
					/>
					<div className="title-page">
						<h3>{t("corporateSearch.title")}</h3>
						<p></p>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className={`g-layout-main ${styles.list_container} `}>
						<div className="g-format-page">
							<div className="g-body-format-page">
								<Profile Profile={updateLocation?.purchase} />
								{updateLocation?.purchase && (
									<div className={styles.container_update_network}>
										<Form id="frmService" name="frmService" layout="vertical" form={frmService} onFinish={handleSubmit}>
											<Row>
												<Col span={8} xl={8} lg={12} md={15} xs={24} sm={24}>
													<Form.Item
														className="input-normal"
														name="oprator"
														label="تغییر شبکه موبایل"
														extra={
															updateLocation.isSuccessfull && (
																<span style={{ color: "#37B399" }}>
																	شبکه شماره {updateLocation.purchase.inT_MSISDN} به {updateLocation.changeOprator} تغییر یافت
																</span>
															)
														}>
														<Select>
															{updateLocation.operator.map((item, key) => (
																<Select.Option key={key} value={item.value}>
																	{" "}
																	{item.name}
																</Select.Option>
															))}
														</Select>
													</Form.Item>
												</Col>
												<Col span={4} xl={4} lg={6} md={15} xs={24} sm={24}>
													<br />
													<div className="holder-button">
														<Button className="btn-normal btn-green" htmlType="submit">
															ثبت
														</Button>
													</div>
												</Col>
											</Row>
										</Form>
									</div>
								)}
							</div>
						</div>
					</Content>
				</div>
				<Loading isOpen={updateLocation.isLoading} />
			</div>
		</>
	);
};

export default UpdateNetwork;
